<template>
  <v-autocomplete
    v-model="select"
    append-icon="place"
    :placeholder="placeholder"
    :label="label"
    :loading="loading"
    :items="computedItems"
    :chips="chips"
    :small-chips="chips"
    :deletable-chips="chips"
    :multiple="multiple"
    @change="change"
    outlined
    cache-items
    dense
    clearable
  >
  </v-autocomplete>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      select: null,
    };
  },
  props: {
    placeholder: {
      type: String,
      default: () => "Seleccione un Lugar",
    },
    label: {
      type: String,
      default: () => "Lugar",
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    chips: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    change(v) {
      console.log(v);
      this.$emit("change", this.select);
    },
  },
  computed: {
    computedItems() {
      return this.items;
    },
  },
};
</script>

<style scoped>
.v-list-item--dense,
.v-list--dense .v-list-item {
  min-height: 20px !important;
}
.v-list--dense .v-list-item .v-list-item__content,
.v-list-item--dense .v-list-item__content {
  padding: 6px 0;
}
</style>